<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt, faTrash, faSpinner, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { fetchExport } from '@/api/exam'
import Pagination from '@/components/Pagination';

library.add( faPencilAlt, faTrash, faSpinner, faFileDownload );

export default {
  name: 'ModuleExamList',
  components: {
    Pagination,
  },
  computed: {
    ...mapState('exam/collection', [
      'items',
      'pagination',
      'isLoading',
    ]),
    page: {
      get() {
        return this.pagination.page;
      },
      set(page) {
        this.setPage(page);
        this.fetch(this.query);
      },
    },
    query() {
      const { query } = this.$route;
      return query.q || null;
    },
  },
  watch: {
    query: function(newQuery, oldQuery) {
      if (newQuery === oldQuery) {
        return;
      }
      this.fetch(newQuery);
    },
  },
  methods: {
    ...mapActions('exam/collection', [
      'fetch',
    ]),
    ...mapMutations('exam/collection', [
      'setPage',
    ]),
    ...mapActions('exam/item', [
      'remove',
    ]),
    confirmDelete(item) {
      this.$dialog.confirm(`Are you sure you want to delete <strong>${item.title}</strong>?`, { loader: true, html: true })
        .then(dialog => this.remove(item.id).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {});
    },
    download(id) {
      fetchExport(id);
    }
  },
  created() {
    this.fetch(this.query);
  },
};
</script>
<template>
  <div class="box">
    <div class="d-flex justify-content-between mb-3">
      <h2>Exams</h2>
      <div class="actions">
        <router-link :to="{ name: 'exams-create' }" class="btn btn-primary">
          New Exam
        </router-link>
      </div>
    </div>
    <table>
      <caption>
        <Pagination :pagination="pagination" :type="'exams'" v-model="page"></Pagination>
      </caption>
      <thead>
        <tr>
          <th>Title</th>
          <th>Pass Rate</th>
          <th>Certificate Counter</th>
          <th class="w-25">Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-if="isLoading">
        <td colspan="8" class="text-center">
          <font-awesome-icon icon="spinner" size="3x" spin class="mt-3 mb-3" />
        </td>
      </tr>
      <tr v-else-if="items.length < 1">
        <td colspan="8" class="text-center">
          There are no exams
        </td>
      </tr>
      <tr v-else v-for="(item, index) in items" :key="item.id" :class="{ primary: index % 2 === 0 }">
        <td>{{ item.title }}</td>
        <td>{{ item.passRate }}</td>
        <td>{{ item.certificateCounter || 0 }}</td>
        <td class="w-25">
          <a @click="download(item.id)" class="pointer text-info mr-3">
            <font-awesome-icon icon="file-download" />
          </a>
          <router-link :to="{ name: 'exams-edit', params: { id: item.id } }" class="mr-3">
            <font-awesome-icon icon="pencil-alt" />
          </router-link>
          <a @click="confirmDelete(item)" class="pointer text-danger">
            <font-awesome-icon icon="trash" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
